import { configureStore } from "@reduxjs/toolkit";

import drawerReducer from "./slices/drawer";
import translationErrorReducer from "./slices/translation";
import playersReducer from "./slices/players";
import kamasutraReducer from "./slices/kamasutra";
import customCategoryReducer from "./slices/customCategory";
import customSoloChallengeReducer from "./slices/customSoloChallenge";
import customDesafioChallengeReducer from "./slices/customDesafioChallenge";
import premiumTrialReducer from "./slices/premiumTrial";

export default configureStore({
  reducer: {
    drawer: drawerReducer,
    translationError: translationErrorReducer,
    players: playersReducer,
    kamasutra: kamasutraReducer,
    customCategory: customCategoryReducer,
    customSoloChallenge: customSoloChallengeReducer,
    customDesafioChallenge: customDesafioChallengeReducer,
    premiumTrial: premiumTrialReducer,
  },
});
